export default function AppId() {
    var nativeForEach;
    var nativeMap;
    var hasher;
    var screen_resolution;
    var screen_orientation;
    var canvas;
    var ie_activex;
    var Fingerprint = function (options) {
        nativeForEach = Array.prototype.forEach;
        nativeMap = Array.prototype.map;
        if (typeof options == "object") {
            hasher = options.hasher;
            screen_resolution = options.screen_resolution;
            screen_orientation = options.screen_orientation;
            canvas = options.canvas;
            ie_activex = options.ie_activex;
        }
        else if (typeof options == "function") {
            hasher = options;
        }
    };
    var hasSessionStorage = function () {
        try {
            return !!window.sessionStorage;
        }
        catch (e) {
            return true;
        }
    };
    var hasLocalStorage = function () {
        try {
            return !!window.localStorage;
        }
        catch (e) {
            return true;
        }
    };
    var murmurhash3_32_gc = function (key, seed) {
        var remainder, bytes, h1, h1b, c1, c2, k1, i;
        remainder = key.length & 3;
        bytes = key.length - remainder;
        h1 = seed;
        c1 = 0xcc9e2d51;
        c2 = 0x1b873593;
        i = 0;
        while (i < bytes) {
            k1 =
                (key.charCodeAt(i) & 0xff) |
                    ((key.charCodeAt(++i) & 0xff) << 8) |
                    ((key.charCodeAt(++i) & 0xff) << 16) |
                    ((key.charCodeAt(++i) & 0xff) << 24);
            ++i;
            k1 =
                ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) &
                    0xffffffff;
            k1 = (k1 << 15) | (k1 >>> 17);
            k1 =
                ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) &
                    0xffffffff;
            h1 ^= k1;
            h1 = (h1 << 13) | (h1 >>> 19);
            h1b =
                ((h1 & 0xffff) * 5 + ((((h1 >>> 16) * 5) & 0xffff) << 16)) & 0xffffffff;
            h1 = (h1b & 0xffff) + 0x6b64 + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16);
        }
        k1 = 0;
        switch (remainder) {
            case 3:
                k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
            case 2:
                k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
            case 1:
                k1 ^= key.charCodeAt(i) & 0xff;
                k1 =
                    ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) &
                        0xffffffff;
                k1 = (k1 << 15) | (k1 >>> 17);
                k1 =
                    ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) &
                        0xffffffff;
                h1 ^= k1;
        }
        h1 ^= key.length;
        h1 ^= h1 >>> 16;
        h1 =
            ((h1 & 0xffff) * 0x85ebca6b +
                ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) &
                0xffffffff;
        h1 ^= h1 >>> 13;
        h1 =
            ((h1 & 0xffff) * 0xc2b2ae35 +
                ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16)) &
                0xffffffff;
        h1 ^= h1 >>> 16;
        return h1 >>> 0;
    };
    var isCanvasSupported = function () {
        var elem = document.createElement("canvas");
        return !!(elem.getContext && elem.getContext("2d"));
    };
    var isIE = function () {
        if (navigator.appName === "Microsoft Internet Explorer") {
            return true;
        }
        else if (navigator.appName === "Netscape" &&
            /Trident/.test(navigator.userAgent)) {
            return true;
        }
        return false;
    };
    //   const getPluginsString = () => {
    //     if (isIE() && ie_activex) {
    //       return getIEPluginsString();
    //     } else {
    //       return getRegularPluginsString();
    //     }
    //   };
    //   const getRegularPluginsString = () => {
    //     return map(
    //       navigator.plugins,
    //       function (p: any) {
    //         var mimeTypes = map(p, function (mt: any) {
    //           return [mt.type, mt.suffixes].join("~");
    //         }).join(",");
    //         return [p.name, p.description, mimeTypes].join("::");
    //       },
    //       this
    //     ).join(";");
    //   };
    var getScreenResolution = function () {
        var resolution;
        if (screen_orientation) {
            resolution =
                screen.height > screen.width
                    ? [screen.height, screen.width]
                    : [screen.width, screen.height];
        }
        else {
            resolution = [screen.height, screen.width];
        }
        return resolution;
    };
    var getCanvasFingerprint = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var txt = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@@#$%^&*()_+-={}|[]:"<>?;,.';
        ctx.textBaseline = "top";
        ctx.font = "14px 'Arial'";
        ctx.textBaseline = "alphabetic";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText(txt, 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText(txt, 4, 17);
        return canvas.toDataURL();
    };
    var getAppId = function () {
        var keys = [];
        keys.push(navigator.userAgent);
        keys.push(navigator.language);
        keys.push(screen.colorDepth);
        if (screen_resolution) {
            var resolution = getScreenResolution();
            if (typeof resolution !== "undefined") {
                keys.push(getScreenResolution().join("x"));
            }
        }
        keys.push(new Date().getTimezoneOffset());
        keys.push(hasSessionStorage());
        keys.push(hasLocalStorage());
        keys.push(!!window.indexedDB);
        //   if (document.body) {
        //     keys.push(typeof document.body.addBehavior);
        //   } else {
        //     keys.push(typeof undefined);
        //   }
        //   keys.push(typeof window.openData);
        //   keys.push(navigator.cpuClass);
        keys.push(navigator.platform);
        keys.push(navigator.doNotTrack);
        // keys.push(getPluginsString());
        if (canvas && isCanvasSupported()) {
            keys.push(getCanvasFingerprint());
        }
        if (hasher) {
            return hasher(keys.join("###"), 31);
        }
        else {
            return murmurhash3_32_gc(keys.join("###"), 31);
        }
    };
    return getAppId();
}
